import React from 'react';
import styles from './ProductDetailPage.module.css';
import Navigation from '../layout/Navigation';
import Footer from '../layout/Footer';
import ProductHero from './heroes/ProductHero';
import SpecificationsSection from '../product-details/SpecificationsSection';
import BenefitsSection from '../product-details/BenefitsSection';
import RelatedProducts from '../product-details/RelatedProducts';
import CTASection from '../product-details/CTASection';

const ProductDetailPage = ({
  heroVariant,
  hero,
  specs,
  benefits,
  benefitsTitle = 'Product Benefits',
  benefitsSubtitle,
}) => (
  <>
    <Navigation />
    <div className={styles.pageWrapper}>
      <div className={styles.bgGlow1} />
      <div className={styles.bgGlow2} />
      <ProductHero variant={heroVariant} content={hero} />
      <SpecificationsSection specs={specs} />
      <BenefitsSection
        benefits={benefits}
        title={benefitsTitle}
        subtitle={benefitsSubtitle}
      />
      <RelatedProducts />
      <CTASection />
    </div>
    <Footer />
  </>
);

export default ProductDetailPage;
